import LegalPageShell from "../components/legal/LegalPageShell";

export default function PrivacyPolicyPage() {
  return (
    <LegalPageShell>
          <h1 className="text-2xl font-bold text-[#5D4D46]">プライバシーポリシー（個人情報保護方針）</h1>

          <p>
            株式会社ウィズダムネットワークス（以下「当社」）は、当社の提供するサービス、および当社が行う事業（以下「本事業」）における、お客様および関係者の皆様の個人情報の取扱いについて、個人情報の保護に関する法律（以下「個人情報保護法」）および関連法令を遵守し、以下のとおりプライバシーポリシー（以下「本ポリシー」）を定めます。
          </p>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">1. 事業者の名称・住所・代表者の氏名</h2>
            <p>株式会社ウィズダムネットワークス</p>
            <p>住所：請求があった場合には、法令に基づき遅滞なく開示します。</p>
            <p>代表取締役社長 伊藤 貴治</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">2. 個人情報の取得と利用目的</h2>
            <p>当社は、定款に定める事業に関連し、各目的の範囲内で個人情報を取得・利用いたします。</p>

            <p>【対象となる事業内容】</p>
            <ol className="list-decimal space-y-2 pl-5">
              <li>情報通信・ネットワークシステムに関するコンサルティング、企画、設計、開発、プロジェクト管理、および運用受託</li>
              <li>コンピュータソフトウェアおよび画像・音楽・映像等のコンテンツの企画、制作、販売、配信、輸出入</li>
              <li>知的財産権（特許権、著作権等）の取得および管理運用</li>
              <li>その他、上記各号に附帯関連する一切の事業</li>
            </ol>

            <p>【利用目的】</p>
            <ul className="space-y-2 pl-5">
              <li>・本事業に関するサービスの提供、契約の履行、および事務手続きのため</li>
              <li>・お客様からのお問い合わせ、ご相談への回答および本人確認のため</li>
              <li>・お取引先様との商談、打ち合わせ、および連絡のため</li>
              <li>・他の事業者等から個人情報の処理の全部または一部について委託された場合等において、委託された当該業務（システム運用受託等）を適切に遂行するため</li>
              <li>・当社サービス、セミナー、展示会等の情報提供（メールマガジン等）のため</li>
              <li>・市場調査、データ分析、および新サービスの研究開発のため</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">3. 安全管理措置に関する事項</h2>
            <p>
              当社は、取り扱う個人データの漏えい、滅失、または毀損の防止その他の個人データの安全管理のため、以下の措置を講じています。
            </p>
            <ul className="space-y-2 pl-5">
              <li>・組織的対策：管理責任者の設置、社内規程の整備、および適正な内部監査の実施</li>
              <li>・人的対策：全役職員に対する定期的な教育・研修の実施</li>
              <li>・物理的・技術的対策：アクセス制限、ウイルス対策、暗号化通信の利用、および盗難・紛失防止措置</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">4. 第三者提供の制限</h2>
            <p>当社は、法令に基づく場合を除き、あらかじめご本人の同意を得ることなく個人情報を第三者に提供しません。</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">5. 業務委託および監督</h2>
            <p>
              当社は、利用目的の達成に必要な範囲内で、個人情報の取扱いを外部に委託する場合があります。この場合、個人情報の保護水準を満たしている委託先を選定し、適切な監督を行います。
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">6. 外国にある第三者への提供</h2>
            <p>
              当社が、クラウドサービスの利用等において外国（米国等）にあるサーバーに個人データを保管する場合、当該外国の個人情報保護制度を把握した上で、適切な安全管理措置を講じます。
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">7. Google API サービスの利用とデータの取扱い</h2>
            <p>
              当社は、領収書・社長メモ・名刺等の紙媒体の情報整理機能において Google Drive および Google スプレッドシートと連携するため、ユーザーの同意を得た上で Google OAuth 2.0 を通じて以下のデータにアクセスします。本項は Google API Services User Data Policy に基づく開示です。
            </p>

            <p className="font-semibold">（1）アクセスするデータ</p>
            <ul className="space-y-2 pl-5">
              <li>
                ・<strong>基本プロフィール情報</strong>（openid / email / profile スコープ）：Google アカウントのメールアドレス、氏名、プロフィール画像。WizMate アカウントとの連携確認に利用します。
              </li>
              <li>
                ・<strong>Google スプレッドシート</strong>（spreadsheets スコープ）：WizMate が紙媒体の情報整理（領収書・社長メモ・名刺等）のために作成・更新するスプレッドシートへの読み取り・書き込みアクセス。ユーザーが作成した既存のスプレッドシートには、WizMate が作成したもの以外はアクセスしません。
              </li>
              <li>
                ・<strong>Google Drive ファイル</strong>（drive.file スコープ）：WizMate が作成したファイル（領収書・社長メモ・名刺等の画像）の保存・参照のみ。ユーザーの Google Drive 全体へのアクセスは行いません。
              </li>
            </ul>

            <p className="font-semibold">（2）利用目的</p>
            <ul className="space-y-2 pl-5">
              <li>・紙媒体の情報整理機能（領収書・社長メモ・名刺等）：AI が紙媒体から読み取った情報をスプレッドシートに記録し、元画像を Google Drive に保存するためにのみ使用します。</li>
              <li>・上記目的以外で Google アカウントデータを利用することはありません。</li>
            </ul>

            <p className="font-semibold">（3）第三者への提供</p>
            <p>
              Google アカウントから取得したデータを、サービスの提供に必要な当社のシステム（AI エージェント処理）以外の第三者と共有・販売・貸与することはありません。広告目的での利用も行いません。
            </p>

            <p className="font-semibold">（4）データの保存と保護</p>
            <ul className="space-y-2 pl-5">
              <li>・OAuth アクセストークンおよびリフレッシュトークンは、暗号化を施した上で安全なストレージに保管します。</li>
              <li>・当社は、Google よりアクセスを許可された目的以外にトークンを使用しません。</li>
            </ul>

            <p className="font-semibold">（5）データの保存期間と削除</p>
            <ul className="space-y-2 pl-5">
              <li>・WizMate アプリ内で「Google 連携を解除」すると、当社が保管しているアクセストークンおよびリフレッシュトークンは即時に削除されます。</li>
              <li>・Google アカウント側からも、Google アカウント設定 → セキュリティ → サードパーティ アクセスにて、WizMate へのアクセス権をいつでも取り消すことができます。</li>
              <li>・メールアドレス等の連携記録を含むデータの削除をご希望の場合は、下記10項のお問い合わせ窓口よりご請求いただけます。法令に従い、合理的な範囲で速やかに対応いたします。</li>
            </ul>

            <p>
              本アプリケーションによる Google API の利用は、
              <a href="https://developers.google.com/terms/api-services-user-data-policy" className="underline underline-offset-4" target="_blank" rel="noopener noreferrer">
                Google API Services User Data Policy
              </a>
              に準拠します（Limited Use 要件を含む）。
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">8. Cookie（クッキー）およびアクセス解析ツールの利用</h2>
            <p>
              当社ウェブサイトでは、利便性向上およびサイト利用状況の把握のため、CookieおよびGoogle Analytics等の解析ツールを使用しています。これらにより取得される情報は匿名であり、個人を特定するものではありません。
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">9. 個人情報の開示・訂正・利用停止等</h2>
            <p>
              お客様が、当社が保有する個人データの利用目的の通知、開示、内容の訂正・追加・削除、または利用の停止・消去を希望される場合は、下記お問い合わせ窓口までご連絡ください。法令に従い、合理的な範囲で速やかに対応いたします。
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-bold text-[#5D4D46]">10. お問い合わせ窓口</h2>
            <p>個人情報の取扱いに関するご質問、または開示等の請求については、以下の窓口までご連絡ください。</p>
            <p>担当：株式会社ウィズダムネットワークス</p>
            <p>個人情報保護窓口：株式会社ウィズダムネットワークス</p>
            <p>
              メールアドレス：
              <a href="mailto:wizmate@wisdomnetworks.co.jp" className="underline underline-offset-4">
                wizmate@wisdomnetworks.co.jp
              </a>
            </p>
            <p>
              お問い合わせ：
              <a href="https://www.wisdomnetworks.co.jp" className="underline underline-offset-4">
                https://www.wisdomnetworks.co.jp
              </a>
            </p>
          </section>

          <p>制定：2005年4月1日 改訂：2026年6月22日</p>
    </LegalPageShell>
  );
}
